/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
import { VideoWrapper } from './styles/Video.styled';

function Video({ videoSrcURL, videoTitle, dir, ...props }) {
  return (
    <VideoWrapper>
      <iframe
        src={videoSrcURL}
        title={videoTitle}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        allowFullScreen
      />
    </VideoWrapper>
  );
}

export default Video;
